import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import WorkflowName from 'automation-ui-references/customer-data/WorkflowName';
import { CLASSIC } from 'automation-ui-flow-core/flow/FlowSourceTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ClassicEnrollInWorkflowActionExplainer({
  action
}) {
  const metadata = action.metadata;
  const {
    workflowId
  } = metadata;
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "automation-ui-action-features.action-features.classic-enroll-in-flow.explainer_jsx",
    options: {
      flowName: /*#__PURE__*/_jsx(WorkflowName, {
        flowSourceType: CLASSIC,
        id: workflowId
      })
    },
    elements: {
      Bold: 'strong'
    }
  });
}